import { GET_PLATFORM_USERS_SUCCESS } from "./actions";

const INIT_STATE = {
  users: [],
};

const PlatformAdminReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PLATFORM_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };
    default:
      return state;
  }
};

export default PlatformAdminReducer;
